export default __webpack_public_path__ + "static/media/not.0634277f.mp3";